import React, {Fragment, useState, useRef, useEffect} from "react";
import {
  TextField,
  AppBar,
  Typography,
  Button,
  Grid,
  Toolbar,
  Collapse,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import {Autocomplete, Alert} from "@material-ui/lab";
import {getCookie} from "components/auth/Helpers";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
const EditDiscount = (props) => {
  const token = getCookie("token");
  const [openAlertSuccess, setOpenAlertSuccess] = useState(false);
  const [openAlertError, setOpenAlertError] = useState(false);
  const [clientValue, setClientValue] = useState({});
  const [fridgesTypeValue, setfridgesTypeValue] = useState({});
  const [oldIsNew, setOldIsNew] = useState();

  const [discount, setDiscount] = useState(props.record[props.record.length - 2] ?? 0);
  const classes = useStyles(); //custom css
  const snRef = useRef();
  const sn2Ref = useRef();
  const typeRef = useRef();
  const brandRef = useRef();
  const clientRef = useRef();
  const submitRef = useRef();

  const handleChange = (e) => {
    const {name, value} = e.target;

    setDiscount(value);
  };
  const handleOnSubmit = async () => {
    if (!discount) return setOpenAlertError(true);

    if (props.recordId) {
      let oldAmount = props.record[props.record.length - 2] ?? 0;

      let total = props.record[props.record.length - 1] ?? 0;

      const newTotal = total + oldAmount - discount;
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BASE_URL}/financial/${props.recordId}`,
        data: [{discount: discount, total: newTotal}],
        headers: {Authorization: `Bearer ${token}`},
      })
        .then(function (response) {
          setOpenAlertSuccess(true);
          props.handleClose();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <Fragment>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Close onClick={props.handleClose} className="btnIcon" />
          <Typography variant="h6" className={classes.title}>
            {props.title}
          </Typography>
        </Toolbar>
        <Grid item container xs={12} md={12}>
          <Grid item xs={12}>
            <p style={{margin: 0, fontSize: "0.9rem", marginLeft: 50}}>
              <strong>Original Total</strong>:{" "}
              {props.record[props.record.length - 2] + props.record[props.record.length - 1]} &nbsp;|&nbsp;
              <strong>Discount</strong>: {props.record[props.record.length - 2] ?? 0} &nbsp;|&nbsp;
              <strong>Total</strong>: {props.record[props.record.length - 1] ?? 0}
            </p>
          </Grid>
        </Grid>
      </AppBar>
      <Collapse in={openAlertSuccess}>
        <Alert severity="success" onClick={() => setOpenAlertSuccess(false)}>
          Discount Updated
        </Alert>
      </Collapse>
      <Collapse in={openAlertError}>
        <Alert severity="error" onClick={() => setOpenAlertError(false)}>
          Missing Discount
        </Alert>
      </Collapse>

      <div style={{padding: "10px 30px"}}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="discount"
              label="Discount"
              name="discount"
              onChange={handleChange}
              fullWidth
              value={discount || ""}
            />
          </Grid>

          <Grid item xs={12} className="clientTables">
            <Button
              variant="contained"
              color="primary"
              size="large"
              className="btn btn--save"
              type="submit"
              startIcon={<Save />}
              ref={submitRef}
              onClick={handleOnSubmit}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              className="btn btn--save"
              onClick={props.handleClose}
              startIcon={<Close />}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default EditDiscount;
